import { useEffect, useState } from "react";

const NAV_ITEMS = [
  { id: "hot", label: "今日热榜", icon: "ri-fire-line" },
  { id: "comments", label: "热门热评", icon: "ri-chat-3-line" },
  { id: "debate", label: "争论焦点", icon: "ri-discuss-line" },
  { id: "topic", label: "话题分类", icon: "ri-grid-fill" },
  { id: "read", label: "专题精选", icon: "ri-article-line" },
  { id: "about", label: "关于我们", icon: "ri-compass-3-line" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || open;

  return (
    <header className="fixed inset-x-0 top-0 z-50">
      <nav
        className={`transition-all duration-300 ${
          solid ? "bg-background-50/95 backdrop-blur border-b border-background-200" : "bg-transparent"
        }`}
      >
        <div className="mx-auto flex items-center justify-between px-4 md:px-6 h-16 md:h-[72px]">
          {/* brand */}
          <a href="#top" className="flex items-center gap-2.5 shrink-0" aria-label="九一吃瓜 首页">
            <span className="relative flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-message-3-fill text-lg" aria-hidden="true"></i>
            </span>
            <span className="leading-none">
              <span className={`block font-heading text-lg md:text-xl font-bold tracking-wide ${solid ? "text-foreground-950" : "text-white"}`}>
                九一吃瓜
              </span>
              <span className={`block text-[11px] md:text-xs ${solid ? "text-foreground-600" : "text-white/80"}`}>
                评论区风向标
              </span>
            </span>
          </a>

          {/* desktop links */}
          <ul className="hidden lg:flex items-center gap-1">
            {NAV_ITEMS.map((item) => (
              <li key={item.id}>
                <a
                  href={`#${item.id}`}
                  className={`flex items-center gap-1.5 whitespace-nowrap px-3 py-2 text-sm rounded-md transition-colors ${
                    solid ? "text-foreground-800 hover:bg-secondary-100 hover:text-foreground-950" : "text-white/90 hover:bg-white/15 hover:text-white"
                  }`}
                >
                  <i className={`${item.icon} text-base`} aria-hidden="true"></i>
                  {item.label}
                </a>
              </li>
            ))}
          </ul>

          <div className="flex items-center gap-2">
            <a
              href="#contact"
              className={`hidden md:inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors cursor-pointer ${
                solid
                  ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                  : "bg-white text-foreground-950 hover:bg-primary-100"
              }`}
            >
              <i className="ri-mail-send-line text-base" aria-hidden="true"></i>
              订阅风向
            </a>
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              aria-label={open ? "关闭菜单" : "打开菜单"}
              aria-expanded={open}
              className={`lg:hidden inline-flex h-10 w-10 items-center justify-center rounded-md border ${
                solid ? "border-background-200 text-foreground-950" : "border-white/40 text-white"
              }`}
            >
              <i className={`${open ? "ri-close-line" : "ri-menu-3-line"} text-xl`} aria-hidden="true"></i>
            </button>
          </div>
        </div>

        {/* mobile panel */}
        {open && (
          <div className="lg:hidden border-t border-background-200 bg-background-50 px-4 md:px-6 py-4">
            <ul className="grid grid-cols-2 gap-2">
              {NAV_ITEMS.map((item) => (
                <li key={item.id}>
                  <a
                    href={`#${item.id}`}
                    onClick={() => setOpen(false)}
                    className="flex items-center gap-2 rounded-md px-3 py-2.5 text-sm text-foreground-800 hover:bg-secondary-100"
                  >
                    <i className={`${item.icon} text-base text-primary-600`} aria-hidden="true"></i>
                    {item.label}
                  </a>
                </li>
              ))}
              <li className="col-span-2">
                <a
                  href="#contact"
                  onClick={() => setOpen(false)}
                  className="mt-1 flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-600"
                >
                  <i className="ri-mail-send-line text-base" aria-hidden="true"></i>
                  订阅每周风向
                </a>
              </li>
            </ul>
          </div>
        )}
      </nav>
    </header>
  );
}